import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Paper, Stack, TextField, Button, Typography, MenuItem, Divider, Alert, Grid, IconButton, Pagination, Select, FormControl, InputLabel } from '@mui/material';
import store from '../store';

const documentTypes = ['机票火车票', '普通发票', '增值税专用发票', '无发票'];
const expenseTypes = ['业务招待费', '误餐费', '交通费', '机票', '火车票', '住宿费', '办公费', '业务成本', '快递费', '物业费', '其他'];
const EmployeeApply = observer(() => {
  const [description, setDescription] = useState('');
  const [reimburseAmount, setReimburseAmount] = useState('');
  const [participants, setParticipants] = useState('');
  const [invoiceNo, setInvoiceNo] = useState('');
  const [sellerName, setSellerName] = useState('');
  const [travelCity, setTravelCity] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [documentType, setDocumentType] = useState('机票火车票');
  const [expenseType, setExpenseType] = useState('业务招待费');
  const [quantity, setQuantity] = useState('');
  const [expenseNote, setExpenseNote] = useState('');
  const [inputTaxItem, setInputTaxItem] = useState('');
  const [amountExclTax, setAmountExclTax] = useState('');
  const [submitOk, setSubmitOk] = useState(false);
  const [submitErr, setSubmitErr] = useState(null);
  const [attachments, setAttachments] = useState([]); // [{filename,url}]
  const [selectedId, setSelectedId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const load = () => store.fetchbx('mine', { page: page, page_size: pageSize });
  useEffect(() => { load(); }, [page, pageSize]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitOk(false); setSubmitErr(null);
    try {
      if (!reimburseAmount || !participants || !invoiceNo || !sellerName) {
        setSubmitErr('请填写必填项：报销金额/参与人/发票号码/销售方名称');
        return;
      }
      const payload = {
        description,
        travel_city: travelCity || null,
        start_time: startTime || null,
        end_time: endTime || null,
        document_type: documentType || null,
        expense_type: expenseType || null,
        quantity: quantity ? parseInt(quantity) : null,
        expense_note: expenseNote || null,
        input_tax_item: inputTaxItem || null,
        amount_excl_tax: amountExclTax ? parseFloat(amountExclTax) : null,
        reimburse_amount: parseFloat(reimburseAmount),
        participants,
        invoice_no: invoiceNo,
        seller_name: sellerName,
        attachments: attachments.map(a => a.filename),
      };
      if (selectedId) {
        await store.updateBX(selectedId, payload);
      } else {
        await store.submitBX(payload);
      }
      setSubmitOk(true);
      window.alert(selectedId ? '更新成功' : '提交成功');
      setReimburseAmount(''); setParticipants(''); setInvoiceNo(''); setSellerName('');
      setTravelCity(''); setStartTime(''); setEndTime(''); setDocumentType('机票火车票'); setExpenseType('业务招待费'); setQuantity(''); setExpenseNote(''); setInputTaxItem(''); setAmountExclTax('');setDescription('');
      setAttachments([]); setSelectedId(null);
      load();
    } catch (e) {
      setSubmitErr(e?.response?.data?.message || '提交失败');
    }
  };

  const onPickRecord = (r) => {
    setSelectedId(r.id);
    setDescription(r.description || '');
    setTravelCity(r.travel_city || '');
    setStartTime(r.start_time || '');
    setEndTime(r.end_time || '');
    setDocumentType(r.document_type || '机票火车票');
    setExpenseType(r.expense_type || '业务招待费');
    setQuantity(r.quantity || '');
    setExpenseNote(r.expense_note || '');
    setInputTaxItem(r.input_tax_item || '');
    setAmountExclTax(r.amount_excl_tax || '');
    setReimburseAmount(r.reimburse_amount || '');
    setParticipants(r.participants || '');
    setInvoiceNo(r.invoice_no || '');
    setSellerName(r.seller_name || '');
    setAttachments((r.attachments || []).map(fn => ({ filename: fn, url: `/api/uploads/${fn}` })));
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const res = await store.uploadAttachment(file);
    setAttachments(prev => [...prev, { filename: res.filename, url: res.url }]);
    e.target.value = '';
  };

  return (
    <Stack spacing={3}>
      <Paper sx={{ p: 3 }}>
        {submitOk && <Alert severity="success" sx={{ mb: 2 }}>提交成功</Alert>}
        {submitErr && <Alert severity="error" sx={{ mb: 2 }}>{submitErr}</Alert>}
        <form onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}><TextField label="出差所在地" value={travelCity} onChange={(e) => setTravelCity(e.target.value)} fullWidth /></Grid>
            <Grid item xs={12} sm={3}><TextField label="开始时间" type="datetime-local" value={startTime} onChange={(e) => setStartTime(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth /></Grid>
            <Grid item xs={12} sm={3}><TextField label="结束时间" type="datetime-local" value={endTime} onChange={(e) => setEndTime(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth /></Grid>
            <Grid item xs={12} sm={6}><TextField select label="单据类型" value={documentType} onChange={(e) => setDocumentType(e.target.value)} fullWidth>{documentTypes.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}</TextField></Grid>
            <Grid item xs={12} sm={6}><TextField select label="费用类型" value={expenseType} onChange={(e) => setExpenseType(e.target.value)} fullWidth>{expenseTypes.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}</TextField></Grid>
            <Grid item xs={12} sm={6}><TextField label="计数量" type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} fullWidth /></Grid>
            <Grid item xs={12} sm={6}><TextField label="进税项" value={inputTaxItem} onChange={(e) => setInputTaxItem(e.target.value)} fullWidth /></Grid>
            <Grid item xs={12} sm={6}><TextField label="报销金额" value={reimburseAmount} onChange={(e) => setReimburseAmount(e.target.value)} required fullWidth type="number" /></Grid>
            <Grid item xs={12} sm={6}><TextField label="不含税金额" type="number" value={amountExclTax} onChange={(e) => setAmountExclTax(e.target.value)} fullWidth /></Grid>
            <Grid item xs={12} sm={6}><TextField label="参与人" value={participants} onChange={(e) => setParticipants(e.target.value)} required fullWidth /></Grid>
            <Grid item xs={12} sm={6}><TextField label="发票号码" value={invoiceNo} onChange={(e) => setInvoiceNo(e.target.value)} required fullWidth /></Grid>
            <Grid item xs={12} sm={6}><TextField label="销售方名称" value={sellerName} onChange={(e) => setSellerName(e.target.value)} required fullWidth /></Grid>
            <Grid item xs={12}><TextField label="说明" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth multiline rows={3} /></Grid>
            {(() => {
              const sr = store.bx.find(r => r.id === selectedId); return sr && sr.review_comment ? (
                <Grid item xs={12}><Alert severity={sr.status === 'rejected' ? 'error' : 'info'}>审核意见：{sr.review_comment}</Alert></Grid>
              ) : null;
            })()}

            {/* 附件上传与缩略图 */}
            <Grid item xs={12}>
              <Stack spacing={1}>
                {/* 计算是否可编辑 */}
                {(() => {
                  const sr = store.bx.find(r => r.id === selectedId); var editable = !selectedId || (sr && (sr.status === 'pending' || sr.status === 'rejected')); return (
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Button component="label" variant="outlined" disabled={!editable}>上传附件
                        <input hidden type="file" onChange={handleUpload} />
                      </Button>
                      {selectedId && <Typography variant="caption" color="text.secondary">当前选择记录：#{selectedId}（{editable ? '可编辑' : '不可编辑'}）</Typography>}
                    </Stack>
                  )
                })()}
                {attachments.length > 0 && (
                  <Stack spacing={1}>
                    {attachments.map((a, idx) => (
                      <Box key={a.filename + idx} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <a href={a.url.startsWith('/api/uploads/') ? a.url : `/api/uploads/${a.filename}`} target="_blank" rel="noreferrer">
                          <Typography variant="body2" sx={{ cursor: 'pointer', textDecoration: 'underline' }}>{a.filename}</Typography>
                        </a>
                        {(() => {
                          const sr = store.bx.find(r => r.id === selectedId); var editable = !selectedId || (sr && (sr.status === 'pending' || sr.status === 'rejected')); return (
                            <Button size="small" color="error" onClick={() => setAttachments(prev => prev.filter((_, i) => i !== idx))} disabled={!editable}>删除</Button>
                          )
                        })()}
                      </Box>
                    ))}
                  </Stack>
                )}
              </Stack>
            </Grid>
            {(() => {
              const sr = store.bx.find(r => r.id === selectedId); var editable = !selectedId || (sr && (sr.status === 'pending' || sr.status === 'rejected')); return (
                <Grid item xs={12}><Button type="submit" variant="contained" disabled={!editable}>{selectedId ? '更新' : '提交'}</Button></Grid>
              )
            })()}
          </Grid>
        </form>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>我的申请</Typography>
        <Divider sx={{ my: 2 }} />
        <Stack spacing={1}>
          {store.bx.map((r) => (
            <Box key={r.id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="body2" sx={{ cursor: 'pointer' }} onClick={() => onPickRecord(r)}>#{r.id} {r.document_type} - {r.expense_type} - ¥{r.reimburse_amount}</Typography>
                  {(() => {
                    const color = r.status === 'pending' ? '#1976d2' : (r.status === 'approved' ? '#2e7d32' : '#d32f2f');
                    const bg = r.status === 'pending' ? 'rgba(25,118,210,0.12)' : (r.status === 'approved' ? 'rgba(46,125,50,0.12)' : 'rgba(211,47,47,0.12)');
                    const text = r.status === 'pending' ? '待审核' : (r.status === 'approved' ? '已通过' : '已驳回');
                    return <Box sx={{ px: 1, py: 0.25, borderRadius: 1, bgcolor: bg, color, fontSize: 12 }}>{text}</Box>;
                  })()}
                </Stack>
                <Typography variant="caption" color="text.secondary">{r.created_at}</Typography>
              </Stack>
              {!(r.status === 'pending' || r.status === 'rejected') && <Typography variant="caption" color="text.secondary">已同意，不可编辑</Typography>}
            </Box>
          ))}
          {store.bx.length === 0 && <Typography variant="body2" color="text.secondary">暂无数据</Typography>}
        </Stack>
        
        {/* 分页组件 */}
        {store.pagination.totalPages > 1 && (
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography variant="body2" color="text.secondary">
                共 {store.pagination.total} 条记录，第 {store.pagination.page} / {store.pagination.totalPages} 页
              </Typography>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>每页条数</InputLabel>
                <Select
                  value={pageSize}
                  label="每页条数"
                  onChange={(e) => {
                    setPageSize(e.target.value);
                    setPage(1);
                  }}
                >
                  <MenuItem value={10}>10条</MenuItem>
                  <MenuItem value={25}>25条</MenuItem>
                  <MenuItem value={50}>50条</MenuItem>
                  <MenuItem value={100}>100条</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            <Pagination
              count={store.pagination.totalPages}
              page={page}
              onChange={(e, newPage) => setPage(newPage)}
              showFirstButton
              showLastButton
              color="primary"
            />
          </Box>
        )}
      </Paper>
    </Stack>
  );
});

export default EmployeeApply;


